import type { StreamingMessageDataType } from './streaming-messages.types';

export function tryFormatJson(data: string): string | null {
  try {
    const trimmed = data.trim();

    if (
      (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
      (trimmed.startsWith('[') && trimmed.endsWith(']'))
    ) {
      return JSON.stringify(JSON.parse(trimmed), null, 2);
    }

    return null;
  } catch {
    return null;
  }
}

function looksLikeJsonPrefix(data: string): boolean {
  const trimmed = data.trimStart();

  return trimmed.startsWith('{') || trimmed.startsWith('[');
}

function looksLikeTruncatedJson(data: string): boolean {
  const trimmed = data.trim();

  if (trimmed.startsWith('{')) {
    return !trimmed.endsWith('}');
  }

  if (trimmed.startsWith('[')) {
    return !trimmed.endsWith(']');
  }

  return false;
}

export function resolveStreamingMessageDataType({
  isBinary,
  data,
  truncated,
}: {
  isBinary: boolean;
  data: string;
  truncated?: boolean;
}): StreamingMessageDataType {
  if (isBinary) {
    return 'binary';
  }

  if (tryFormatJson(data) !== null) {
    return 'json';
  }

  if (
    looksLikeJsonPrefix(data) &&
    (truncated === true || looksLikeTruncatedJson(data))
  ) {
    return 'json';
  }

  return 'text';
}
